import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[chartPopup]'
})
export class ChartPopupDirective {

  @Input() theme!: string;

  constructor(public tpl: TemplateRef<any>) {
  }

}
